export type ContentWidth = 'Fluid' | 'Fixed';
export type LogoTheme = 'logoCard' | 'logoImgCard';
export type MenuTheme = 'light' | 'dark';

export interface PureSettings {
  themeConfig: {
    [key: string]: string;
  };
  primaryColor?: string;
  navTheme?: MenuTheme | undefined;
  contentWidth?: ContentWidth;
  fixedHeader?: boolean; // sticky header
  isHideHeader?: boolean;
  autoHideHeader?: boolean; // auto hide header
  fixSiderbar?: boolean; // sticky siderbar
  publicPath?: string;
}

export interface RenderSetting {
  multiTabs?: boolean; // multiple Tabs mode
  title?: string; // multiple Tabs mode
}

export type ProSettings = PureSettings & RenderSetting;

const defaultSettings: ProSettings = {
  themeConfig: {
    // theme主题配置项
    '@ant-prefix': 'portal',
  },
  contentWidth: 'Fluid', // layout of content: Fluid or Fixed, only works when layout is topmenu
  multiTabs: process.env.NODE_ENV === 'development', // multiple Tabs mode
  fixedHeader: false, // sticky header
  autoHideHeader: false, // auto hide header
  fixSiderbar: false, // sticky siderbar
  isHideHeader: process.env.NODE_ENV !== 'development', // 结合multiTabs使用,主要是提供界面给第三方嵌入
  // navTheme: 'dark', // dark/light 目前是固定死light
  title: 'DSCM-web',
  // logoTheme: 'logoCard', // logoCard/logoImgCard
  // layout: 'topmenu', // nav menu position: sidemenu or topmenu
  // showloginTheme: true, // show login theme
  // defaultLanguage: 'en-US', // 前后端默认语言
  // allOrgDetail: true, // 组织详情表单是否显示全部
  publicPath: '/dscm',
};

export default defaultSettings;
